import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../../styles/institucional.css";
import CardsInstitucional from "../../components/CardsInstitucional/CardsInstitucional";
import maos from "../../img/maos.png";
import Footer from "../../components/Footer/Footer";
import logoBranca from "../../img/logoBranca.png";
import AlinhamentoInstitucional from "../../components/AlinhamentoInstituto/AlinhamentoInstituto";
import CardsConselheiros from "../../components/CardsConselheiros/CardsConselheiros";
import CardsConselheirosConsultivo from "../../components/CardsConselheirosConsultivo/CardsConselheirosConsultivo";
import DocumentosInstitucionais from "../../components/DocumentosInstitucionais/DocumentosInstitucionais";
import { Link } from "react-router-dom";

function institucional() {
  return (
    <div>
      <Navbar expand="lg" className="bg-body-tertiary" id="navbar">
        <Container fluid>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <Navbar.Brand to="/" id="brand">
            <a href="/">
              <img
                src={logoBranca}
                style={{ width: "auto", marginLeft: "15px" }}
              />
            </a>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="me-auto my-2 my-lg-0"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              <Link
                to="/institucional"
                style={{
                  color: "#fff",
                  marginLeft: "60px",
                  fontWeight: "400",
                  textDecoration: "none",
                }}
              >
                Institucional
              </Link>
              <Link
                to="/"
                style={{
                  color: "#fff",
                  marginLeft: "60px",
                  fontWeight: "400",
                  textDecoration: "none",
                }}
              >
                Atuação
              </Link>
              {/* <Link to="/blog" style={{color: '#fff', marginLeft:'60px', fontWeight:'400', textDecoration: 'none'}}>Blog e notícias</Link> */}
              <Link
                to="/formulario"
                style={{
                  color: "#fff",
                  marginLeft: "60px",
                  fontWeight: "400",
                  textDecoration: "none",
                }}
              >
                Incentivos fiscais
              </Link>
              <Link
                to="/"
                style={{
                  color: "#fff",
                  marginLeft: "60px",
                  fontWeight: "400",
                  textDecoration: "none",
                }}
              >
                Contato
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div className="parteBranca" style={{ alignItems: "center" }}>
        <div class="row m-auto" style={{ marginTop: "5%" }}>
          <div class="col" style={{ marginLeft: "10%" }}>
            <p className="instituto">O Instituto</p>
            <br />
            <AlinhamentoInstitucional />
          </div>
          <div class="col-12 col-md-6" style={{ marginLeft: "5%" }}>
            <img src={maos} id="maos" className="img-fluid" />
          </div>
        </div>
        <br />
        <br />
        <br />
      </div>
      <div className="parteBaixo">
        <p className="transparencia">Transparência e Responsabilidade</p>
        <p className="governanca">Governança Corporativa</p>
        <p className="textInst">
          A governança é fundamental para promover transparência, eficiência e{" "}
          <br /> responsabilidade, garantindo o sucesso e a sustentabilidade de
          uma organização.
        </p>
        <CardsInstitucional />
        <br />
        <br />
        <br />
      </div>
      <div className="parteBranca" style={{ alignItems: "center" }}>
        <p className="conselheiros">Conselheiros</p>
        <p className="governanca">Conselho de Administração</p>
        <CardsConselheiros />
      </div>
      <div className="parteBaixo">
        <p className="conselheiros">Conselheiros</p>
        <p className="governanca">Conselho Consultivo</p>
        <CardsConselheirosConsultivo />
        <br />
        <br />
        <br />
      </div>
      <DocumentosInstitucionais />
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default institucional;
